import { useState as uS, useEffect as uE, useRef as uR } from 'react';
import { Stage as S, Layer as L, Image as K } from 'react-konva';
import uIm from '../../hooks/useImage';

const CamCanvas = ({ overlay: o, size: sz }) => {
    const [vs, setVs] = uS(null), [vEl, setVEl] = uS(null), [dim, setDim] = uS({ width: 0, height: 0 }), [err, setErr] = uS(null);
    const cRef = uR(null), vLRef = uR(null), oLRef = uR(null), aRef = uR(null), oIm = uIm(o);

    uE(() => {
        let vid;
        const iCam = async () => {
            try {
                const devs = await navigator.mediaDevices.enumerateDevices();
                const vDevs = devs.filter(d => d.kind === 'videoinput');
                let sCam = vDevs.find(d => d.label.toLowerCase().includes('back')) ||
                    vDevs.find(d => d.label.toLowerCase().includes('rear')) ||
                    vDevs[0];

                const con = sCam.deviceId ?
                    { video: { deviceId: { exact: sCam.deviceId } } } :
                    { video: true };

                const strm = await navigator.mediaDevices.getUserMedia(con);
                vid = document.createElement('video');
                vid.srcObject = strm;
                vid.autoplay = true;
                vid.playsInline = true;
                vid.onloadedmetadata = () => {
                    setVEl(vid);
                    setVs(strm);
                };
                vid.onerror = () => setErr('Video element error');
            } catch (e) {
                if (e.name === 'NotAllowedError') setErr('دسترسی به دوربین ممنوع شد.');
                else if (e.name === 'NotFoundError') setErr('دستگاه دوربینی پیدا نشد.');
                else if (e.name === 'NotReadableError') { setErr('دوربین در حال استفاده است.'); iCam() }
                else if (e.name === 'OverconstrainedError') setErr('محدودیتی برای دوربین وجود دارد.');
                else setErr('خطا: ' + e.message);
            }
        };

        navigator.permissions.query({ name: 'camera' }).then(p => {
            if (p.state === 'granted') iCam();
            else if (p.state === 'prompt') {
                navigator.mediaDevices.getUserMedia({ video: true })
                    .then(() => iCam())
                    .catch(e => setErr('خطا: ' + e.message));
            } else setErr('اجازه دوربین داده نشد.');
        });

        return () => {
            if (vs) vs.getTracks().forEach(t => t.stop());
            if (vid) {
                vid.pause();
                vid.srcObject = null;
            }
            if (aRef.current) cancelAnimationFrame(aRef.current);
        };
    }, []);

    uE(() => {
        const uDim = () => {
            if (cRef.current) setDim({
                width: cRef.current.offsetWidth,
                height: cRef.current.offsetHeight,
            });
        };
        uDim();
        window.addEventListener('resize', uDim);
        return () => window.removeEventListener('resize', uDim);
    }, []);

    uE(() => {
        const dF = () => {
            if (vEl && vLRef.current) {
                const cnv = vLRef.current.getCanvas()._canvas;
                const ctx = cnv.getContext('2d');

                if (vEl.readyState >= vEl.HAVE_CURRENT_DATA) {
                    const vW = vEl.videoWidth, vH = vEl.videoHeight;
                    const cW = dim.width, cH = dim.height;

                    const vAR = vW / vH, cAR = cW / cH;
                    let dW, dH, oX, oY;

                    if (vAR > cAR) {
                        dW = cH * vAR; dH = cH; oX = (cW - dW) / 2; oY = 0;
                    } else {
                        dW = cW; dH = cW / vAR; oX = 0; oY = (cH - dH) / 2;
                    }

                    ctx.clearRect(0, 0, cnv.width, cnv.height);
                    ctx.drawImage(vEl, oX, oY, dW, dH);
                    vLRef.current.batchDraw();
                }
                aRef.current = requestAnimationFrame(dF);
            }
        };

        dF();
        return () => {
            if (aRef.current) cancelAnimationFrame(aRef.current);
        };
    }, [vEl, dim]);

    uE(() => {
        if (oIm && oLRef.current) oLRef.current.batchDraw();
    }, [oIm]);

    return (
        <div ref={cRef} className="relative w-full h-full">
            {err && (
                <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-red-600 bg-opacity-75 text-white text-lg p-4">
                    {err}
                </div>
            )}
            <S width={dim.width} height={dim.height}>
                <L ref={vLRef} />
                <L ref={oLRef}>
                    {oIm && (
                        <K
                            image={oIm}
                            x={250} y={100}
                            draggable
                            width={(sz.width * 2.9)}
                            height={(sz.height * 2.9)}
                            shadowColor="rgba(0, 0, 0, 0.5)"
                            shadowBlur={3}
                            shadowOffsetX={1}
                            shadowOffsetY={1}
                        />
                    )}
                </L>
            </S>
        </div>
    );
};

export default CamCanvas;
